'use client'

import { Builder, withChildren } from '@builder.io/react'

import { FontStyles, OfferCard } from './OfferCard'
import { OfferPrice } from './OfferPrice'
import { Columns, OfferSubtitleChecks } from './OfferSubtitleChecks'

Builder.registerComponent(withChildren(OfferCard), {
  name: 'OfferCard',
  noWrap: true,
  inputs: [
    {
      name: 'featuredLabel',
      type: 'string',
      friendlyName: 'Featured label',
    },
    {
      name: 'featuredLabelPadding',
      type: 'number',
      defaultValue: 16,
      friendlyName: 'Featured label horizontal padding',
    },
    {
      name: 'featuredFontStyle',
      type: 'enum',
      defaultValue: 'text-body-md',
      enum: FontStyles,
      friendlyName: 'Featured font styles',
    },
    {
      name: 'featuredColor',
      type: 'color',
      defaultValue: '#825BB5',
      friendlyName: 'Featured color',
    },
    {
      name: 'featuredBorderWidth',
      type: 'number',
      defaultValue: 2,
      friendlyName: 'Featured border width',
    },
    {
      name: 'featuredBannerAlignment',
      type: 'enum',
      defaultValue: 'center',
      enum: ['left', 'center', 'right'],
      friendlyName: 'Featured banner alignment',
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#FFFFFF',
      friendlyName: 'Background color',
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/receipt-2.svg',
})

Builder.registerComponent(OfferPrice, {
  name: 'OfferCardPriceInfo',
  inputs: [
    {
      name: 'oldPrice',
      type: 'string',
      defaultValue: '30',
      friendlyName: 'Old price',
    },
    {
      name: 'newPrice',
      type: 'string',
      defaultValue: '15',
      friendlyName: 'New price',
    },
    {
      name: 'copyTop',
      type: 'string',
      defaultValue: '12 month plan',
      friendlyName: 'Copy top',
    },
    {
      name: 'copyBottom',
      type: 'string',
      defaultValue: 'Billed $179 annually*',
      friendlyName: 'Copy bottom',
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/zoom-money.svg',
})

Builder.registerComponent(OfferSubtitleChecks, {
  name: 'OfferSubtitleChecks',
  inputs: [
    {
      name: 'items',
      type: 'list',
      defaultValue: [
        {
          value: '4 new BODi Blocks each month',
        },
      ],
      subFields: [{ name: 'value', type: 'html' }],
    },
    {
      name: 'checkColor',
      type: 'color',
      defaultValue: 'var(--color-bodi-accent-bright-700)',
    },
    {
      name: 'columns',
      type: 'string',
      enum: Columns as any,
      defaultValue: '2',
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/list-check.svg',
})
